export default __webpack_public_path__ + "static/media/3-pieces-upper-mantle.3d1369e0.svg";